module.exports = __webpack_public_path__ + "img/foundationPrimer.076ffd3b.png";